const ServerErrorException = (message) => {
  const error = new Error(message);
  return error;
};

ServerErrorException.prototype = Object.create(Error.prototype);

export default ServerErrorException;
